import { useSelector } from "react-redux";
import { State } from "../state";
import styles from "./about.module.css";

function AboutPage(): JSX.Element {
  const { data: languageData } = useSelector((state: State) => state.languageReducer);
  const aboutText = languageData?.about ?? {};

  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <h1 className={styles.title}>
          {aboutText.hero?.title || "Transform Your Gas Station Management"}
        </h1>
        <p className={styles.subtitle}>
          {aboutText.hero?.subtitle || "Comprehensive solution for modern gas station operations"}
        </p>
      </section>

      {/* Main Features Section */}
      <section className={styles.features}>
        <div className={styles.featureGroup}>
          <h2>{aboutText.features?.turpak?.title || "TURPAK Integration"}</h2>
          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <span className={styles.icon}>🔄</span>
              <h3>{aboutText.features?.turpak?.realTime || "Real-Time Sync"}</h3>
              <p>{aboutText.features?.turpak?.realTimeDesc || "Instant synchronization with TURPAK systems for up-to-the-minute data accuracy"}</p>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.icon}>📊</span>
              <h3>{aboutText.features?.turpak?.reporting || "Automated Reporting"}</h3>
              <p>{aboutText.features?.turpak?.reportingDesc || "Comprehensive reporting system with detailed analytics and insights"}</p>
            </div>
          </div>
        </div>

        <div className={styles.featureGroup}>
          <h2>{aboutText.features?.cashFlow?.title || "Cash Flow Management"}</h2>
          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <span className={styles.icon}>💰</span>
              <h3>{aboutText.features?.cashFlow?.tracking || "Real-Time Tracking"}</h3>
              <p>{aboutText.features?.cashFlow?.trackingDesc || "Monitor cash transactions and balances in real-time"}</p>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.icon}>🏦</span>
              <h3>{aboutText.features?.cashFlow?.banking || "Bank Integration"}</h3>
              <p>{aboutText.features?.cashFlow?.bankingDesc || "Seamless bank deposit tracking and reconciliation"}</p>
            </div>
          </div>
        </div>

        <div className={styles.featureGroup}>
          <h2>{aboutText.features?.creditCard?.title || "Credit Card Processing"}</h2>
          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <span className={styles.icon}>💳</span>
              <h3>{aboutText.features?.creditCard?.processing || "Transaction Processing"}</h3>
              <p>{aboutText.features?.creditCard?.processingDesc || "Efficient credit card transaction management and tracking"}</p>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.icon}>📱</span>
              <h3>{aboutText.features?.creditCard?.mobile || "Mobile Support"}</h3>
              <p>{aboutText.features?.creditCard?.mobileDesc || "Process transactions on-the-go with mobile support"}</p>
            </div>
          </div>
        </div>

        <div className={styles.featureGroup}>
          <h2>{aboutText.features?.employee?.title || "Employee Management"}</h2>
          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <span className={styles.icon}>👥</span>
              <h3>{aboutText.features?.employee?.shifts || "Shift Management"}</h3>
              <p>{aboutText.features?.employee?.shiftsDesc || "Comprehensive shift tracking and management system"}</p>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.icon}>📈</span>
              <h3>{aboutText.features?.employee?.performance || "Performance Tracking"}</h3>
              <p>{aboutText.features?.employee?.performanceDesc || "Monitor employee performance and transaction accuracy"}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className={styles.benefits}>
        <h2>{aboutText.benefits?.title || "Why Choose Our Solution?"}</h2>
        <div className={styles.benefitsList}>
          <div className={styles.benefitItem}>
            <h3>{aboutText.benefits?.efficiency || "Increased Efficiency"}</h3>
            <p>{aboutText.benefits?.efficiencyDesc || "Streamline operations and reduce manual work"}</p>
          </div>
          <div className={styles.benefitItem}>
            <h3>{aboutText.benefits?.accuracy || "Better Accuracy"}</h3>
            <p>{aboutText.benefits?.accuracyDesc || "Minimize errors with automated systems"}</p>
          </div>
          <div className={styles.benefitItem}>
            <h3>{aboutText.benefits?.control || "Complete Control"}</h3>
            <p>{aboutText.benefits?.controlDesc || "Full oversight of all operations"}</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className={styles.cta}>
        <h2>{aboutText.cta?.title || "Ready to Optimize Your Operations?"}</h2>
        <p>{aboutText.cta?.subtitle || "Join the leading gas stations using our solution"}</p>
        <button className={styles.ctaButton}>
          {aboutText.cta?.button || "Contact Us Today"}
        </button>
      </section>
    </div>
  );
}

export default AboutPage; 